











































































import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import {Medium} from '@/models/Medium'
import MediaSelector from '@/components/admin/MediaSelector.vue'
import Recruit from '@/models/Recruit'
import JobForm from '@/components/admin/recruits/JobForm.vue'

@Component({
  components: {
    JobForm,
    TinyMce,
    MediaSelector
  }
})
export default class AddinForm extends VueBase {
  @Prop(Object) readonly post!: Recruit
  showedMediaSelector = false
  plans = [
    {
      text: '未定',
      value: 'pending'
    },
    {
      text: '無料掲載企業',
      value: 'basic'
    },
    {
      text: '人材紹介サービス契約企業',
      value: 'pro'
    }
  ]

  onSelectMedium(media: Array<Medium>): void {
    this.post.company_image1 = media[0]
    this.post.company_image2 = media[1]
    this.post.company_image3 = media[2]
    this.showedMediaSelector = false
  }

  clearImages(): void {
    this.post.company_image1 = undefined
    this.post.company_image2 = undefined
    this.post.company_image3 = undefined
  }
}
